import { Col, Row } from 'react-bootstrap';
import {
  HeadingDesc,
  HeadingWithSpace,
  SectionHeadingSmall
} from '../Headings';
import img from '../../assets/images/png/resource.png';
import { SimpleButton } from '../button';
import './resource.css';

function Resource() {
  return (
    <section className="resource">
      <Row>
        <Col md={3}>
          <div className="img_box">
            <img src={img} alt="img" />
          </div>
        </Col>
        <Col md={6}>
          <div className="content">
            <HeadingWithSpace text="MERI SEHAT RESOURCE" />
            <SectionHeadingSmall text="Can climate change affect your health?" />
            <HeadingDesc text="We know the impacts climate change can have on our planet, but what effects can it have on our health? Healthline’s TRANSFORM: Future of Health series explores what’s next in health and wellness." />
            <SimpleButton text="explore" bgColor="#29BCC1" />
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default Resource;
